if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.#thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.#thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Variant gallery: variant photos stay hidden until a variant is chosen

			this.#variantGalleryInit();

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.#onVariantChangeHandler.bind(this));
				this.#onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				this._buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				this._buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		disconnectedCallback(){
			if ( this._buyObserver ) {
				this._buyObserver.disconnect();
			}
		}

		#thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail:not(.vg-hide)').forEach((elm, i)=>{
				if ( i == index ) {
					elm.classList.add('active');
					this.querySelector('.product-gallery__thumbnails-holder').scrollTo({
						left: elm.offsetLeft - 50,
						behavior: 'smooth'
					})
				} else {
					elm.classList.remove('active');
				}
			});
		}

		// Variant gallery
		// Photos that belong to a variant (other than the main product photo) are
		// parked outside the slider until that variant is selected in the dropdown.
		// Data and the pre-script CSS come from snippets/variant-gallery-data.liquid.

		#variantGalleryInit(){

			if ( ! this.productSlider || ! this.productGallery ) return;

			const dataElm = this.productGallery.querySelector('script[data-variant-gallery-data]');
			if ( ! dataElm ) return;

			try {
				const data = JSON.parse(dataElm.textContent);
				this._vg = {
					hidden: new Set((data.hidden || []).map(String)),
					map: data.map || {},
					current: data.pre ? String(data.pre) : null,
					focus: !! data.pre,
					applied: false,
					waiting: false
				};
			} catch (err) {
				this._vg = null;
				return;
			}

			this.#variantGalleryRequest(null);

		}

		#variantGalleryRequest(variant){

			const vg = this._vg;
			if ( ! vg ) return;

			if ( variant ) {
				const mediaId = vg.map[String(variant.id)];
				vg.current = mediaId ? String(mediaId) : null;
				vg.focus = !! vg.current;
			}

			if ( this.productSlider.sliderEnabled ) {
				this.#variantGalleryApply();
			} else if ( ! vg.waiting ) {
				vg.waiting = true;
				this.productSlider.addEventListener('ready', ()=>{
					vg.waiting = false;
					this.#variantGalleryApply();
				}, { once: true });
			}

		}

		#variantGalleryApply(){

			const vg = this._vg;
			const slider = this.productSlider;

			if ( ! vg.slides ) {
				vg.slides = Array.from(slider.querySelectorAll('.product-gallery-item'));
				vg.grid = vg.slides.length ? vg.slides[0].parentNode : null;
				vg.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumbnails .thumbnail'));
				vg.thumbHolder = this.querySelector('.product-gallery__thumbnails');
				vg.stash = document.createElement('div');
				vg.stash.hidden = true;
				vg.stash.setAttribute('data-variant-gallery-stash', '');
				this.productGallery.appendChild(vg.stash);
			}
			if ( ! vg.grid ) return;

			const show = vg.slides.map(slide=>{
				const id = slide.dataset.mediaId;
				return ! vg.hidden.has(id) || id === vg.current;
			});

			// park hidden photos, then place the visible ones back in their original order

			vg.slides.forEach((slide, i)=>{
				if ( ! show[i] ) {
					slide.classList.remove('vg-show');
					if ( slide.parentNode !== vg.stash ) {
						vg.stash.appendChild(slide);
					}
				}
			});

			let ref = null;
			for ( let i = vg.slides.length - 1; i >= 0; i-- ) {
				if ( ! show[i] ) continue;
				const slide = vg.slides[i];
				slide.classList.add('vg-show');
				if ( slide.parentNode !== vg.grid || slide.nextElementSibling !== ref ) {
					vg.grid.insertBefore(slide, ref);
				}
				ref = slide;
			}

			// thumbnails follow the same list and get renumbered to match the slider

			let visibleCount = 0;
			vg.thumbs.forEach((thumb, i)=>{
				if ( show[i] ) {
					thumb.classList.add('vg-show');
					thumb.classList.remove('vg-hide');
					thumb.dataset.index = visibleCount++;
				} else {
					thumb.classList.remove('vg-show');
					thumb.classList.add('vg-hide');
				}
			});
			if ( vg.thumbHolder ) {
				vg.thumbHolder.classList.toggle('vg-hide', visibleCount < 2);
			}

			// rebuild the slider around the visible photos, then move to the selected variant's photo

			let position = 0, count = 0;
			vg.slides.forEach((slide, i)=>{
				if ( show[i] ) {
					if ( vg.focus && slide.dataset.mediaId === vg.current ) {
						position = count;
					}
					count++;
				}
			});

			slider.afterAppend();
			slider.resetSlider(true, true);
			slider.changeSlide(position, vg.applied ? 'smooth' : 'auto');
			vg.applied = true;

		}

		#onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( this._vg ) {

					this.#variantGalleryRequest(variant);

				} else if ( variant.featured_media?.id ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
						}
					}
				}
				
				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}
		
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
